import React, { useEffect, useState } from "react";

import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  OutlinedInput,
  Chip,
} from "@mui/material";

import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  allGames,
  deleteFilePath,
  updateGameDetail,
  updateGameDetailformData,
} from "../../redux/Slices/extSlice";

import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  height: "80vh",
  overflow: "scroll",
  scrollbarWidth: "none", // For Firefox
  msOverflowStyle: "none", // For Internet Explorer and Edge
  "&::-webkit-scrollbar": {
    display: "none", // For Chrome, Safari, and Opera
  },
};
const UpdateGame = ({
  handleClose,
  updateId,
  testimonialtoupdate,
  categories,
}) => {
  const dispatch = useDispatch();
  const [FormDatas, setFormData] = useState({
    ...testimonialtoupdate[0],
    icon_img: testimonialtoupdate[0].icon_img || "",
    screenshots: Array.isArray(testimonialtoupdate[0].screenshots) 
      ? testimonialtoupdate[0].screenshots 
      : [],
  });
  const [editorState, setEditorState] = useState(() => {
    const blocksFromHtml = htmlToDraft(testimonialtoupdate[0].description);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );
    return EditorState.createWithContent(contentState);
  });
  const [convertedContent, setConvertedContent] = useState(null);

  // const _contentState = ContentState.createFromText(
  //   testimonialtoupdate[0].description
  // );
  // const raw = convertToRaw(_contentState); // RawDraftContentState JSON
  // const [contentState, setContentState] = useState(raw); // ContentState JSON
  // const [convertedState, setconvertedState] = useState(); // ContentState JSON

  // console.log(contentState, "contentState");
  useEffect(() => {
    const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setFormData((prevData) => ({
      ...prevData,
      description: html,
    }));
    setConvertedContent(html);
  }, [editorState]);
  const handleSelectChange = (e) => {
    const { value } = e.target;
    setFormData({
      ...FormDatas,
      cat_arr: typeof value === "string" ? value.split(",") : value,
    });
    //  console.log("Updated fields:", fields); // Note: This might not show the latest state due to closure
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const hasFeaturedFile =
      FormDatas.featured_img && typeof FormDatas.featured_img !== "string";
    const hasIconFile =
      FormDatas.icon_img && typeof FormDatas.icon_img !== "string";
    // Check if there are new screenshot files (File objects, not strings)
    const hasNewScreenshots = 
      Array.isArray(FormDatas.screenshots) && 
      FormDatas.screenshots.some(screenshot => screenshot instanceof File);
    let useFormData = hasFeaturedFile || hasIconFile || hasNewScreenshots;

    const formData = new FormData();
    // if (typeof FormDatas.game_file !== "string") {
    //   // formData.append(
    //   //   "game_file",
    //   //   FormDatas.game_file,
    //   //   FormDatas.game_file.name
    //   // );
    //   useFormData = true;
    // }
    if (hasFeaturedFile || hasIconFile) {
      useFormData = true;
    }

    if (Array.isArray(FormDatas.cat_arr)) {
      formData.append("cat_arr", JSON.stringify(FormDatas.cat_arr));
    }

    if (useFormData) {
      Object.keys(FormDatas).forEach((key) => {
        if (
          key !== "game_file" &&
          key !== "featured_img" &&
          key !== "icon_img" &&
          key !== "screenshots" &&
          key !== "cat_arr"
        ) {
          formData.append(key, FormDatas[key]);
        }
      });

      if (hasFeaturedFile) {
        formData.append(
          "featured_img",
          FormDatas.featured_img,
          FormDatas.featured_img.name
        );
      }
      if (hasIconFile) {
        formData.append("icon_img", FormDatas.icon_img, FormDatas.icon_img.name);
      }

      // Handle screenshots - append File objects (new uploads) and existing paths
      if (Array.isArray(FormDatas.screenshots) && FormDatas.screenshots.length > 0) {
        // Separate existing screenshot paths (strings) from new File objects
        const existingScreenshots = FormDatas.screenshots.filter(
          (screenshot) => typeof screenshot === "string"
        );
        const newScreenshots = FormDatas.screenshots.filter(
          (screenshot) => screenshot instanceof File
        );

        // Append new screenshot files
        newScreenshots.forEach((screenshot) => {
          formData.append("screenshots", screenshot);
        });

        // Append existing screenshot paths as JSON (to preserve them)
        if (existingScreenshots.length > 0) {
          formData.append("existing_screenshots", JSON.stringify(existingScreenshots));
        } else {
          // If no existing screenshots, send empty array to clear all
          formData.append("existing_screenshots", JSON.stringify([]));
        }
      } else {
        // If screenshots array is empty, send empty array
        formData.append("existing_screenshots", JSON.stringify([]));
      }

      // if (typeof FormDatas.game_file !== "string") {
      //   formData.append(
      //     "game_file",
      //     FormDatas.game_file,
      //     FormDatas.game_file.name
      //   );
      // }

      dispatch(updateGameDetailformData(formData)).then((data) => {
        const datatosend = { cat: "all" };
        dispatch(allGames(datatosend));
        handleClose();
        toast.success("Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      });
    } else {
      // console.log("in else useFormData", useFormData);
      dispatch(updateGameDetail(FormDatas)).then((data) => {
        const datatosend = { cat: "all" };
        dispatch(allGames(datatosend));
        handleClose();
        toast.success("Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      });
    }
  };

  const handleGamesChange = (e) => {
    setFormData({ ...FormDatas, [e.target.name]: e.target.value });
  };

  const handleImageChange = (fieldName, file) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: file,
    }));
  };

  /**
   * Handle image deletion
   * Deletes the image file from server and updates the database
   * @param {string} fieldName - Name of the image field (e.g., "featured_img", "icon_img")
   */
  const handleImageDelete = (fieldName) => {
    const currentValue = FormDatas[fieldName];
    
    // If it's a string (existing file path), delete from server
    if (typeof currentValue === "string" && currentValue) {
      const data = {
        pathtodelete: `https://www.punogames.com/assets${currentValue}`,
        documentId: FormDatas._id,
        field: fieldName,
      };

      dispatch(deleteFilePath(data))
        .then((res) => {
          if (res.payload?.code === 200) {
            setFormData((prev) => ({ ...prev, [fieldName]: "" }));
            toast.success("Image deleted successfully", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          } else {
            toast.error("Unable to delete image", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        })
        .catch((error) => {
          console.error("Error deleting image:", error);
          toast.error("Error deleting image", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        });
    } 
    // If it's a File object (newly uploaded but not saved), just remove from state
    else {
      setFormData((prev) => ({ ...prev, [fieldName]: "" }));
    }
  };

  const getImageSrc = (fieldName) => {
    const value = FormDatas[fieldName];
    if (!value) return null;
    if (typeof value === "string") {
      return `https://www.punogames.com/assets${value}`;
    }
    return URL.createObjectURL(value);
  };

  /**
   * Handle screenshot deletion
   * Removes screenshot from the array and deletes file from server if it's an existing screenshot
   * @param {number} index - Index of the screenshot to delete
   */
  const handleScreenshotDelete = (index) => {
    const screenshots = FormDatas.screenshots || [];
    const screenshotToDelete = screenshots[index];

    // Remove from array immediately (optimistic update)
    const updatedScreenshots = screenshots.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, screenshots: updatedScreenshots }));

    // If it's a string (existing file path), delete from server
    if (typeof screenshotToDelete === "string" && screenshotToDelete) {
      const data = {
        pathtodelete: `https://www.punogames.com/assets${screenshotToDelete}`,
        documentId: FormDatas._id,
        field: "screenshots_array", // Special field to indicate array update needed
        screenshotPath: screenshotToDelete, // The path to remove from array
      };

      dispatch(deleteFilePath(data))
        .then((res) => {
          if (res.payload?.code === 200) {
            toast.success("Screenshot deleted successfully", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
            // Refresh the games list to show updated data
            const datatosend = { cat: "all" };
            dispatch(allGames(datatosend));
          } else {
            // If deletion failed, restore the screenshot
            setFormData((prev) => ({ ...prev, screenshots }));
            toast.error("Unable to delete screenshot", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        })
        .catch((error) => {
          console.error("Error deleting screenshot:", error);
          // Restore the screenshot on error
          setFormData((prev) => ({ ...prev, screenshots }));
          toast.error("Error deleting screenshot", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        });
    } else {
      // If it's a File object (new upload), already removed from array above
      toast.success("Screenshot removed", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  /**
   * Handle screenshot upload
   * Adds new screenshot files to the screenshots array
   * @param {Event} e - File input change event
   */
  const handleScreenshotUpload = (e) => {
    const files = Array.from(e.target.files);
    setFormData((prevData) => ({
      ...prevData,
      screenshots: [...(prevData.screenshots || []), ...files],
    }));
    // Reset input to allow selecting the same file again
    e.target.value = "";
  };

  // Create a map of category IDs to category names for easy lookup
  const categoryMap = React.useMemo(() => {
    const map = new Map();
    if (categories && Array.isArray(categories)) {
      categories.forEach((cat) => {
        const idStr = String(cat._id);
        map.set(idStr, cat.cat_name);
        if (cat._id) {
          map.set(cat._id, cat.cat_name);
        }
      });
    }
    return map;
  }, [categories]);

  // Helper function to get category name from ID
  const getCategoryName = (categoryId) => {
    const idStr = String(categoryId);
    return categoryMap.get(categoryId) || categoryMap.get(idStr) || categoryId;
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <div>
      <Box sx={style}>
        <Button color="error" onClick={handleClose} sx={{ marginLeft: "90%" }}>
          <CancelOutlinedIcon />
        </Button>
        <Typography
          variant="h6"
          style={{ paddingBottom: "20px", textAlign: "center" }}
        >
          Updating Game: {FormDatas.game_name || FormDatas.title || "Game"}
        </Typography>

        <form onSubmit={handleSubmit}>
          <div style={{ display: "flex", gap: "20px" }}>
            <div
              style={{
                flex: "3",
                display: "flex",
                gap: "12px",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <div style={{ flex: "1" }}>
                {/* Featured Image Section */}
                <Box sx={{ marginBottom: 3 }}>
                  <Typography sx={{ fontWeight: 600, marginBottom: 1.5 }}>
                    Featured Image
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      marginBottom: 2,
                    }}
                  >
                    <Button
                      variant="contained"
                      component="label"
                      disabled={!!FormDatas.featured_img}
                      size="small"
                    >
                      {FormDatas.featured_img
                        ? "Featured Image Uploaded"
                        : "Upload Featured Image"}
                      <input
                        type="file"
                        accept="image/png, image/gif, image/jpeg, image/jpg, image/webp"
                        hidden
                        onChange={(e) => {
                          if (e.target.files[0]) {
                            handleImageChange("featured_img", e.target.files[0]);
                          }
                        }}
                      />
                    </Button>
                  </Box>

                  {FormDatas.featured_img && (
                    <Box
                      sx={{
                        width: 150,
                        height: 150,
                        borderRadius: 2,
                        overflow: "hidden",
                        border: "1px solid #ddd",
                        position: "relative",
                        backgroundColor: "#f5f5f5",
                      }}
                    >
                      <img
                        src={getImageSrc("featured_img")}
                        alt="Featured"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      <Button
                        onClick={() => handleImageDelete("featured_img")}
                        size="small"
                        sx={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          minWidth: "28px",
                          height: "28px",
                          backgroundColor: "rgba(255, 255, 255, 0.9)",
                          "&:hover": {
                            backgroundColor: "rgba(255, 0, 0, 0.1)",
                          },
                        }}
                      >
                        ×
                      </Button>
                    </Box>
                  )}
                </Box>
                {Object.keys(testimonialtoupdate[0])
                  .slice(0, 6)
                  .filter(
                    (key) =>
                      key !== "game_link" &&
                      key !== "game_name" &&
                      key !== "featured_img" &&
                      key !== "icon_img"
                  )
                  .map((key) => {
                    if (
                      key === "_id" ||
                      key === "game_name" ||
                      key === "game_link" ||
                      key === "featured_img" ||
                      key === "icon_img"
                    )
                      return null;

                    if (key === "description")
                      return (
                        <div
                          key={key}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "20px",
                          }}
                        >
                          {/* <TextField
                            label={key.replace(/_/g, " ").toUpperCase()}
                            defaultValue={testimonialtoupdate[0][key]}
                            // inputRef={inputRefs[key]}
                            multiline
                            sx={{ width: "100%" }}
                            name={key}
                            onChange={handleGamesChange}
                            maxRows={4}
                          /> */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "20px",
                              maxWidth: "90%",
                            }}
                          >
                            <div style={{ width: "100%" }}>
                              <p style={{ paddingLeft: "5px" }}>
                                GAME DESCRIPTION
                              </p>

                              {/* <Editor
                                editorState={editorState}
                                onEditorStateChange={handleEditorChange}
                                wrapperClassName="wrapper-class"
                                editorClassName="editor-class"
                                toolbarClassName="toolbar-class"
                              /> */}
                              <Editor
                                editorState={editorState}
                                onEditorStateChange={setEditorState}
                                wrapperClassName="wrapper-class"
                                editorClassName="editor-class"
                              />
                            </div>
                            <div style={{ width: "100%" }}>
                              <p style={{ paddingLeft: "5px" }}>HTML</p>
                              <div style={{ width: "100%", height: "100px" }}>
                                <textarea
                                  style={{ width: "100%", height: "100px" }}
                                  value={convertedContent}
                                  placeholder="Type anything…"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );

                    if (key === "layout") {
                      return (
                        <Box sx={{ minWidth: 120, marginBottom: "20px" }}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Layout
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              name="layout"
                              value={FormDatas.layout}
                              label="Layout"
                              onChange={handleGamesChange}
                              //  onChange={handleChangeLayout}
                            >
                              <MenuItem value={"portrait"}>Portrait</MenuItem>
                              <MenuItem value={"landscape"}>Landscape</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      );
                    }

                    return (
                      <div
                        key={key}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "20px",
                        }}
                      >
                        <TextField
                          label={key.replace(/_/g, " ").toUpperCase()}
                          defaultValue={testimonialtoupdate[0][key]}
                          // inputRef={inputRefs[key]}
                          sx={{ width: "100%" }}
                          name={key}
                          onChange={handleGamesChange}
                        />
                      </div>
                    );
                  })}
              </div>
              <div style={{ flex: "1" }}>
                {/* Icon Image Section */}
                <Box sx={{ marginBottom: 3 }}>
                  <Typography sx={{ fontWeight: 600, marginBottom: 1.5 }}>
                    Game Icon
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      marginBottom: 2,
                    }}
                  >
                    <Button
                      variant="contained"
                      component="label"
                      disabled={!!FormDatas.icon_img}
                      size="small"
                    >
                      {FormDatas.icon_img
                        ? "Icon Uploaded"
                        : "Upload Icon"}
                      <input
                        type="file"
                        accept="image/png, image/gif, image/jpeg, image/jpg, image/webp"
                        hidden
                        onChange={(e) => {
                          if (e.target.files[0]) {
                            handleImageChange("icon_img", e.target.files[0]);
                          }
                        }}
                      />
                    </Button>
                  </Box>

                  {FormDatas.icon_img && (
                    <Box
                      sx={{
                        width: 120,
                        height: 120,
                        borderRadius: 2,
                        overflow: "hidden",
                        border: "1px solid #ddd",
                        position: "relative",
                        backgroundColor: "#f5f5f5",
                      }}
                    >
                      <img
                        src={getImageSrc("icon_img")}
                        alt="Game Icon"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      <Button
                        onClick={() => handleImageDelete("icon_img")}
                        size="small"
                        sx={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          minWidth: "28px",
                          height: "28px",
                          backgroundColor: "rgba(255, 255, 255, 0.9)",
                          "&:hover": {
                            backgroundColor: "rgba(255, 0, 0, 0.1)",
                          },
                        }}
                      >
                        ×
                      </Button>
                    </Box>
                  )}
                </Box>

                {/* Screenshots Section */}
                <Box sx={{ marginBottom: 3 }}>
                  <Typography sx={{ fontWeight: 600, marginBottom: 1.5 }}>
                    Game Screenshots
                  </Typography>
                  <Button
                    variant="contained"
                    component="label"
                    size="small"
                    sx={{
                      backgroundColor: "#6A4FE0",
                      "&:hover": { backgroundColor: "#5a43c5" },
                      marginBottom: 2,
                    }}
                  >
                    Upload Screenshots
                    <input
                      type="file"
                      hidden
                      multiple
                      accept="image/*"
                      onChange={handleScreenshotUpload}
                    />
                  </Button>

                  {/* Display existing and new screenshots */}
                  {FormDatas.screenshots && FormDatas.screenshots.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 2,
                        marginTop: 2,
                      }}
                    >
                      {FormDatas.screenshots.map((screenshot, index) => {
                        const imageSrc =
                          typeof screenshot === "string"
                            ? `https://www.punogames.com/assets${screenshot}`
                            : URL.createObjectURL(screenshot);

                        return (
                          <Box
                            key={index}
                            sx={{
                              width: 150,
                              height: 150,
                              borderRadius: 2,
                              overflow: "hidden",
                              border: "1px solid #ddd",
                              position: "relative",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            <img
                              src={imageSrc}
                              alt={`Screenshot ${index + 1}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <Button
                              onClick={() => handleScreenshotDelete(index)}
                              size="small"
                              sx={{
                                position: "absolute",
                                top: 4,
                                right: 4,
                                minWidth: "28px",
                                height: "28px",
                                backgroundColor: "rgba(255, 255, 255, 0.9)",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 0, 0, 0.1)",
                                },
                              }}
                            >
                              ×
                            </Button>
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Box>

                {Object.keys(testimonialtoupdate[0])
                  .slice(6, Object.keys(testimonialtoupdate[0]).length)
                  .filter(
                    (key) =>
                      key !== "cat_arr" &&
                      key !== "game_link" &&
                      key !== "game_name" &&
                      key !== "featured_img" &&
                      key !== "icon_img" &&
                      key !== "screenshots" &&
                      !key.includes("img")
                  )
                  .map((key) => {
                    if (
                      key === "_id" ||
                      key === "screenshots" ||
                      key === "game_file" ||
                      key === "game_link" ||
                      key === "cat_arr" ||
                      key === "game_name" ||
                      key === "featured_img" ||
                      key === "icon_img" ||
                      key.includes("img")
                    )
                      return null;

                    if (key === "description")
                      return (
                        <div
                          key={key}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "20px",
                          }}
                        >
                          <TextField
                            label={key.replace(/_/g, " ").toUpperCase()}
                            defaultValue={testimonialtoupdate[0][key]}
                            // inputRef={inputRefs[key]}
                            multiline
                            sx={{ width: "100%" }}
                            name={key}
                            onChange={handleGamesChange}
                            maxRows={4}
                          />
                        </div>
                      );

                    if (key === "category_names") {
                      return (
                        <FormControl key={key} style={{ marginBlock: "20px" }}>
                          <InputLabel id="demo-multiple-chip-label">
                            {" "}
                            {"CATEGORIES"}
                          </InputLabel>
                          <Select
                            labelId="demo-multiple-chip-label"
                            id="demo-multiple-chip"
                            multiple
                            // value={testimonialtoupdate[0][key]}
                            value={FormDatas.cat_arr}
                            onChange={handleSelectChange}
                            input={
                              <OutlinedInput
                                id="select-multiple-chip"
                                label="Chip"
                              />
                            }
                            renderValue={(selected) => (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((categoryId) => {
                                  const categoryName = getCategoryName(categoryId);
                                  return (
                                    <Chip
                                      key={categoryId}
                                      label={categoryName}
                                      size="small"
                                    />
                                  );
                                })}
                              </Box>
                            )}
                            MenuProps={MenuProps}
                          >
                            {categories?.map((category) => {
                              return (
                                <MenuItem
                                  key={category._id}
                                  value={category._id}
                                >
                                  {category.cat_name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      );
                    }

                    return (
                      <div
                        key={key}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "20px",
                        }}
                      >
                        <TextField
                          label={key.replace(/_/g, " ").toUpperCase()}
                          defaultValue={testimonialtoupdate[0][key]}
                          // inputRef={inputRefs[key]}
                          sx={{ width: "100%" }}
                          name={key}
                          onChange={handleGamesChange}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
        </form>
        
      </Box>
    </div>
  );
};

export default UpdateGame;

// {
//   <div
//     key={index}
//     style={{
//       display: "flex",
//       alignItems: "center",
//       marginBottom: "10px",
//     }}
//   >
//     <TextField
//       label={`Screenshot ${index + 1}`}
//       value={screenshot}
//       onChange={(e) => handleScreenshotChange(index, e.target.value)}
//       sx={{ width: "90%" }}
//     />
//     <IconButton
//       onClick={() => handleDeleteScreenshot(index)}
//       aria-label="delete"
//     >
//       <DeleteIcon />
//     </IconButton>
//   </div>;
// }
